class NumberStepper {
	constructor(stepper) {
		if (!stepper) {
			return;
		}

		this.stepper = stepper;

		this.minusBtn = this.stepper.querySelector('.js-number-stepper-minus');

		this.plusBtn = this.stepper.querySelector('.js-number-stepper-plus');

		this.field = this.stepper.querySelector('.js-number-stepper-input');

		this.stepUpVal = parseInt(this.plusBtn.dataset.step);
		this.stepDownVal = parseInt(this.minusBtn.dataset.step);

		this.checkMinMax = this.field.dataset.checkMinmax ? true : false;


		this._init();
	}

	_init() {
		this._checkVal();

		this.field.setAttribute('readonly', true);

		this.plusBtn.addEventListener(
			'click',
			() => this._increment(this.stepUpVal),
			false
		);

		this.minusBtn.addEventListener(
			'click',
			() => this._decrement(this.stepDownVal),
			false
		);

		this.field.addEventListener('input', () => this._checkVal(), false);
	}

	checkVal() {
		this._checkVal()
	}

	_checkVal() {
		this.minVal = parseInt(this.field.min);
		this.maxVal = parseInt(this.field.max);

		let currVal = parseInt(this.field.value);

		if (currVal <= this.minVal) {
			this.minusBtn.disabled = true;
			this.minusBtn.classList.add('is-disabled');

			if (this.checkMinMax) {
				this.field.value = this.minVal;
			}
		} else {
			this.minusBtn.disabled = false;
			this.minusBtn.classList.remove('is-disabled');
		}

		if (currVal >= this.maxVal) {
			this.plusBtn.disabled = true;
			this.plusBtn.classList.add('is-disabled');
			if (this.checkMinMax) {
				this.field.value = this.maxVal;
			}
		} else {
			this.plusBtn.disabled = false;
			this.plusBtn.classList.remove('is-disabled');
		}
	}

	_increment(val) {
		this.field.value = parseInt(this.field.value) + val;
		this._checkVal();
	}

	_decrement(val) {
		this.field.value = parseInt(this.field.value) - val;
		this._checkVal();
	}
}

export default NumberStepper;
